import { shortRootGetter } from '../../../../utils/vuex'

const TEAM_NUM = 3 // 每组3个人

export default {
  myUid: shortRootGetter('account/myUid'),
  getUser: shortRootGetter('laxin/getUser'),

  leader(state, getters) {
    return getters.getUser(state.teamUid)
  },

  // 当前登录用户，是否为队长
  isLeader(_, getters) {
    const { myUid, leader } = getters
    return !!leader && myUid > 0 && myUid === leader.uid
  },

  // 当前登录用户，是否为被邀请者
  isInvited(state, getters) {
    const { inviteInfo } = state
    const { myUid } = getters
    return myUid > 0 && inviteInfo && inviteInfo.inviteUid === myUid
  },

  inviteGroups(state) {
    const { inviteList } = state
    const groups = []
    const { length } = inviteList
    for (let i = 0; i < length; i += TEAM_NUM) {
      const group = []
      for (let j = i, l = Math.min(i + TEAM_NUM, length); j < l; j++) {
        group.push(inviteList[j])
      }
      groups.push(group)
    }
    return groups
  }
}
